import { useEffect } from "react";

// Stabile Kurz-URL für Social-Bios: dickies-helden.de/buch → aktuelles Amazon-Buch
const AMAZON_URL = "https://amzn.eu/d/0hDnoUOg";

export default function BuchRedirect() {
  useEffect(() => {
    window.location.replace(AMAZON_URL);
  }, []);
  return (
    <div className="min-h-screen flex items-center justify-center bg-cream-100">
      <p className="text-sand-600 text-sm" data-testid="buch-redirect">
        Einen Moment – du wirst zu Amazon weitergeleitet …
      </p>
    </div>
  );
}
